import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { useState, useEffect } from "react";
import { ImSpinner2 } from "react-icons/im";
import Home from "./pages/Home/Home";
import PublicLayout from "./pages/PublicLayout";
import Furnitures from "./pages/Furnitures/Furnitures";
import About from "./pages/About/About";
import FurnitureDetails from "./pages/Furnitures/FurnitureDetails";
import Terms from "./pages/Legal/Terms";
import { Contact } from "./pages/Contact/Contact";
import logo from "./assets/logo/logonew.png";

function App() {
  const alreadyLoaded = sessionStorage.getItem("wh_loaded");
  const [loading, setLoading] = useState(!alreadyLoaded);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (alreadyLoaded) return;
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem("wh_loaded", "true");
      }, 500);
    }, 1800);
    return () => clearTimeout(timer);
  // eslint-disable-next-line
  }, []);

  if (loading) {
    return (
      <div
        className={`fixed inset-0 bg-linen flex flex-col items-center justify-center z-[9999] transition-opacity duration-500 ${fadeOut ? "opacity-0" : "opacity-100"}`}
      >
        <img src={logo} alt="Weaving Hands" className="h-24 w-auto mb-6 object-contain" />
        <span className="font-serif text-charcoal tracking-[0.3em] uppercase text-lg mb-8">Weaving Hands</span>
        <ImSpinner2 className="text-brass text-3xl animate-spin" />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path={`${process.env.PUBLIC_URL}/`} element={<PublicLayout />}>
          <Route exact path={`${process.env.PUBLIC_URL}/`} element={<Home />} />
          <Route exact path={`${process.env.PUBLIC_URL}/furnitures`} element={<Furnitures />} />
          <Route path="/furniture/:id" element={<FurnitureDetails />} />
          <Route exact path={`${process.env.PUBLIC_URL}/about`} element={<About />} />
          <Route exact path={`${process.env.PUBLIC_URL}/terms-conditions`} element={<Terms />} />
          <Route exact path={`${process.env.PUBLIC_URL}/contact`} element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
